import {I18nLang} from 'ngx-satoris';
import {CardPayment, RequestMNTAType} from 'src/app/shared/models/request';
import {AppEnvironment} from './environment.model';
import {UserPlatformRole} from 'src/app/shared/models/user';
export const environment: AppEnvironment = {
  production: false,
  appVersion: [7, 2, 0],
  appBuild: 'build-localhost',
  devtool: true,

  baseUri: 'https://api-epvisa.semlex-secure.org/api/v1/', //baseUri: 'https://10.150.1.211:5000/api/v1/',
  backupUri: 'https://api-epvisa.semlex-secure.org/api/v1/', //backupUri: 'https://10.150.1.211:5000/api/v1/',
  authUri: 'http://10.3.0.97:30301/api/v1/',
  exchangeSupportsLdap: true,
  referenceUri: 'http://10.3.0.97:30303/registry/read-only-view/person?referenceNumber=',
  baseHref: '',

  name: 'Comoros eGuichet',
  supportSource: 'https://glpi-app.satoris.lu/install.js?project=comtest&lang=en&position=bottomRight&btnVisible=false',
  faqSource: <string>undefined,

  smsIntent: 'INTENT',

  theme: {
    logo: 'assets/logo.svg',
    logoFullAlt: 'assets/logo-full-alt.png',
    flag: '',
    header_background: ''
  },

  supportedLanguages: [I18nLang.FR, I18nLang.AR, I18nLang.EN],
  nationalityNoDeclaration: ['COM'],
  supportedCurrencies: ['KMF', 'EUR'],
  supportedCardCurrencies: ['EUR'],
  enableWelcomeFlow: false,
  countryPhonePrefix: 0,
  noConfirm: true,
  visaDocumentsMaxTotalSizeMb: 300,
  civilMajority: 18,
  formHasUrgentStep: false, //TODO: remove this upon refactoring of the form multi step
  formHasTravelNameStep: false,
  formHasPassportTypeStep: false,
  formHasBookTimeSlotStep: false,
  formReasonRequestStep: true,
  hasMultiPersonView: false,
  hasShowcase: false,
  defaultRoute: '',
  logoutRoute: '',
  showFormVisaDisclaimers: false,
  useCustomLoadingElement: false,
  useAwsForUploads: false,
  enableAdminRequestSelectWatchlist: false,
  enableCrossCheckApiPNR: false,
  hasPrepareLandingVisa: false,
  adminSelectRequestDisabled: false,
  paymentChoiceType: false,
  allowCreate: true,
  enableMagicLinkLoginByEmail: false,
  enableMagicLinkLoginBySms: false,
  reminderPaperToBring: false,
  useGuichet: true,
  showWelcome: true,
  contactSupportMailto: false,
  canDisablePlace: false,
  showPaymentInstructions: true,
  autoDiscardOldQueue: false,
  usesFaceDetectionForCapture: true,
  recordPaymentWorkerPass: true,
  allowExtension: false,
  requireInternalReference: false,
  showSeniority: false,
  showLogoPrint: false,
  showVerificationQr: false,
  alwaysShowQr: true,
  hideNoctisConsumerUsersInUsersTable: true,
  showEmblemPrint: false,
  showresidentCardPenaltyInSummaryPage: false,
  useDropdownSeniority: true,
  seniorityName: false,
  showScrollButton: true,
  showSearchFromDocument: false,
  showImportantNotice: false,
  nextApplicationButton: false,
  printApprovalNNI: true,
  printApprovalCreatedAt: true,
  seniorityOptions: true,
  allowOnlyOnePerm: true,
  showBackground: false,
  showDemandReference: false,
  filterRolesForUserCreation: [UserPlatformRole.CUSTOMER, UserPlatformRole.KIOSK],
  noWebp: true,
  requireLegalAcceptance: false,
  requireCookieConsent: false,
  csvDownloadLimit: 0,

  partner1Url: '',
  partner2Url: '',
  partnerPoweredByUrl: '',

  personFields: ['firstName', 'lastName', 'nationalNumber', 'birthDate', 'sex', 'birthPlaceCity', 'birthPlaceCountry', 'linkType'],
  supportedPayments: [CardPayment.VISA, CardPayment.MASTERCARD, CardPayment.AMERICAN_EXPRESS],
  supportedPaymentProviders: [RequestMNTAType.PAYPAL],
  supportContactEmail: '',

  domain: 'interior.gov.km',
  kioskUsername: 'info@satoris.lu',
  password: 'wwwXXX0000'
};
